<template>
  <div class="card-wrap">
    <Divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">{{title}}</Divider>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type:String,
      default:'文字'
    }
  },
  data() {
    return{}
  }
}
</script>

<style lang="less" scoped>
.card-wrap{
  background: #ffffff;
  overflow: hidden;
  padding-bottom: 16px;
  margin-bottom: 10px;
  box-shadow:0px 2px 8px 0px rgba(211,214,242,0.5);
  border-radius:3px;
}
</style>